import { buildLineBroadcastCooldownKey } from './lineBroadcastCooldown'

export const MID_AUTUMN_ACTIVITY_ID = 62
export const MID_AUTUMN_START = Date.parse('2026-09-15T00:00:00+08:00')
export const MID_AUTUMN_END = Date.parse('2026-09-28T00:00:00+08:00')
export const MID_AUTUMN_DISMISS_MS = 24 * 60 * 60 * 1000
export const MID_AUTUMN_DISMISS_EVENT = 'dentco:mid-autumn-2026:dismiss'
export const MID_AUTUMN_PREVIEW_URL = 'https://preview.dentco.tw/mid-autumn-2026'
export const MID_AUTUMN_SUPPORT_URL = 'https://lin.ee/8HDgGr5'

const fallbackDismissals = new Map()
export const ACTIVITY_TABS = Object.freeze([
  { key: 'education', type: 1, label: '衛教套版', contentType: 1 },
  { key: 'festival', type: 2, label: '節慶套版', contentType: 1 },
  { key: 'function', type: 3, label: '功能套版', contentType: 1 },
  { key: 'custom', type: null, label: '自定義圖片/文字', contentType: 2 }
])

export function isMidAutumnActive(now = Date.now()) {
  return now >= MID_AUTUMN_START && now < MID_AUTUMN_END
}

export function buildMidAutumnDismissalKey(auth = {}) {
  // Reuse only the existing account identity rules, never read/write cooldown state.
  const identityKey = buildLineBroadcastCooldownKey(auth)
  return identityKey ? `dentco:campaign:mid-autumn-2026:dismissed:${identityKey.split(':').slice(4).join(':')}` : null
}

function getStorage(source) {
  try {
    return source || (typeof window === 'undefined' ? null : window.localStorage)
  } catch (error) {
    return null
  }
}

export function isMidAutumnDismissed(dismissedAt, now = Date.now()) {
  const value = Number(dismissedAt)
  return Number.isFinite(value) && value > 0 && value <= now && now < value + MID_AUTUMN_DISMISS_MS
}

export function readMidAutumnDismissal(key, now = Date.now(), source) {
  if (!key) return 0
  let value = fallbackDismissals.get(key)
  try {
    const storage = getStorage(source)
    if (storage && !isMidAutumnDismissed(value, now)) value = storage.getItem(key)
  } catch (error) {
    // A failed browser storage read must not interrupt the message editor.
  }
  return isMidAutumnDismissed(value, now) ? Number(value) : 0
}

export function writeMidAutumnDismissal(key, dismissedAt, source) {
  if (!key || !Number.isFinite(dismissedAt) || dismissedAt <= 0) return false
  fallbackDismissals.set(key, dismissedAt)
  try {
    const storage = getStorage(source)
    if (!storage) return false
    storage.setItem(key, String(dismissedAt))
    fallbackDismissals.delete(key)
    return true
  } catch (error) {
    return false
  }
}

export function clearMidAutumnFallback(key) {
  if (key) fallbackDismissals.delete(key)
  else fallbackDismissals.clear()
}

export function nextMidAutumnRefreshDelay(now, dismissedAt) {
  const boundaries = [MID_AUTUMN_START, MID_AUTUMN_END, dismissedAt + MID_AUTUMN_DISMISS_MS]
    .filter(value => value > now)
  // The one-minute ceiling also handles system-clock corrections without timer overflow.
  return Math.max(1, Math.min(60000, ...boundaries.map(value => value - now)))
}

export function getActivityTabs(active) {
  return active ? [ACTIVITY_TABS[1], ACTIVITY_TABS[0], ...ACTIVITY_TABS.slice(2)] : ACTIVITY_TABS
}

export function getInitialActivityTab(value, activities, now = Date.now()) {
  if (value.type === 2) return 'custom'
  const selected = activities.find(activity => activity.id === value.activity)
  const descriptor = selected && ACTIVITY_TABS.find(tab => tab.type === selected.type)
  return descriptor ? descriptor.key : (isMidAutumnActive(now) ? 'festival' : 'education')
}
